var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visible ? _c('dialog', [_c('p', [_vm._v("You are about to navigate away from the Course. Are you sure you want to leave?")]), _c('button', {
    on: {
      "click": _vm.okHandler
    }
  }, [_vm._v("Im Sure")]), _c('button', {
    on: {
      "click": _vm.closeHandler
    }
  }, [_vm._v("Cancel")])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }